import axios from "axios";

const lang = localStorage.getItem('lang') || 'en';

const http = axios.create({
  baseURL: axios.defaults.baseURL,
  headers: {
    "Content-type": "application/json",
    Accept: "application/json",
    "Accept-Language": lang,
  },
});

http.interceptors.request.use(
  (config) => {
    config.headers["Accept-Language"] = localStorage.getItem('lang') || 'en';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    if (error.response && error.response.status === 429 && (!config._retryCount || config._retryCount < 3)) {
      config._retryCount = (config._retryCount || 0) + 1;
      const delay = Math.pow(2, config._retryCount) * 1000;
      await new Promise((resolve) => setTimeout(resolve, delay));
      return http(config);
    }
    if (error.response && error.response.status === 404) {
      window.location.href = '/404';
    }
    return Promise.reject(error);
  }
);

export default http;
